import { House, Menu, Search } from 'lucide-react'
import { useState } from 'react'
import { NavLink } from 'react-router'
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet'
import { t } from '@/lib/text'
import { cn } from '@/lib/utils'
import { useShell } from './ShellContext'
import { NavList } from './Sidebar'

const itemClasses =
  'flex min-h-14 flex-1 flex-col items-center justify-center gap-1 text-xs font-medium text-muted-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50'

/** Phones (< 768 px): Home · Search · More. "+" joins when a module registers a New entry (M2). */
export function BottomBar() {
  const { openPalette } = useShell()
  const [moreOpen, setMoreOpen] = useState(false)
  return (
    <>
      <nav
        aria-label={t('core.nav.bottom_label')}
        className="fixed inset-x-0 bottom-0 z-30 flex border-t bg-background pb-[env(safe-area-inset-bottom)] md:hidden"
      >
        <NavLink to="/" end className={({ isActive }) => cn(itemClasses, isActive && 'text-primary')}>
          <House className="size-5" aria-hidden />
          {t('core.nav.home')}
        </NavLink>
        <button type="button" className={itemClasses} onClick={openPalette}>
          <Search className="size-5" aria-hidden />
          {t('core.nav.search')}
        </button>
        <button type="button" className={itemClasses} onClick={() => setMoreOpen(true)} aria-haspopup="dialog">
          <Menu className="size-5" aria-hidden />
          {t('core.nav.more')}
        </button>
      </nav>
      <Sheet open={moreOpen} onOpenChange={setMoreOpen}>
        <SheetContent side="bottom" closeLabel={t('core.shell.close')} aria-describedby={undefined}>
          <SheetHeader>
            <SheetTitle>{t('core.nav.more')}</SheetTitle>
          </SheetHeader>
          <div className="px-2 pb-4">
            <NavList onNavigate={() => setMoreOpen(false)} />
          </div>
        </SheetContent>
      </Sheet>
    </>
  )
}
